const GET_MEMBER_NOTIFICATIONLIST_REQUEST = 'GET_MEMBER_NOTIFICATIONLIST_REQUEST';
const GET_MEMBER_NOTIFICATIONLIST_SUCCESS = 'GET_MEMBER_NOTIFICATIONLIST_SUCCESS';
const GET_MEMBER_NOTIFICATIONLIST_FAILURE = 'GET_MEMBER_NOTIFICATIONLIST_FAILURE';

const GET_MEMBER_NOTIFICATIONLIST_MORE_REQUEST = 'GET_MEMBER_NOTIFICATIONLIST_MORE_REQUEST';
const GET_MEMBER_NOTIFICATIONLIST_MORE_SUCCESS = 'GET_MEMBER_NOTIFICATIONLIST_MORE_SUCCESS';
const GET_MEMBER_NOTIFICATIONLIST_MORE_FAILURE = 'GET_MEMBER_NOTIFICATIONLIST_MORE_FAILURE';

const APPLY_MEMBER_NOTIFICATION_REQUEST = 'APPLY_MEMBER_NOTIFICATION_REQUEST';
const APPLY_MEMBER_NOTIFICATION_SUCCESS = 'APPLY_MEMBER_NOTIFICATION_SUCCESS';
const APPLY_MEMBER_NOTIFICATION_FAILURE = 'APPLY_MEMBER_NOTIFICATION_FAILURE';

export const RECEIVE_INSTANT_NOTIFICATION = 'RECEIVE_INSTANT_NOTIFICATION';

const initState = {
	list: [],
	offset: 0,
    newCount: 0,
    totalCount: 0,
};

import * as backend from 'backend-helpers/memberNotificationList';

export default function memberNotificationList(state = initState, action) {

    if (action.type === GET_MEMBER_NOTIFICATIONLIST_SUCCESS) {

        return {
            ...state,
            ...action.result.data.data
        }
    }

    if (action.type === GET_MEMBER_NOTIFICATIONLIST_MORE_SUCCESS) {
        let {
        	list,
            offset,
        } = action.result.data.data;

        list = [...state.list, ...list];

        return {
            ...state,
            ...action.result.data.data,
            list
        }
    }

    if (action.type === APPLY_MEMBER_NOTIFICATION_SUCCESS) {
        const {
            totalCount,
            processedList
        } = action.result.data.data;

        const list = state.list.map((item, i) => {
            processedList.map((itemPr, l) => {
                item.id === +itemPr ? item.is_read = 0 : false;
            });
            return item;
        });

        if(state.totalCount === state.offset) {
            return {
                ...state,
                list,
            }
        }
    }

    if (action.type === RECEIVE_INSTANT_NOTIFICATION) {
        if (!action.onlyToast) {
            action.data.data.date = action.data.data.date * 1000;
            return {
                ...state,
                list: [ action.data, ...state.list ]
            }
        }
        return state;
    }
    return state;
}

export const getMemberNotificationList = data => ({
    types: [GET_MEMBER_NOTIFICATIONLIST_REQUEST, GET_MEMBER_NOTIFICATIONLIST_SUCCESS, GET_MEMBER_NOTIFICATIONLIST_FAILURE],
    promise: backend.getMemberNotificationList(data),
    data
});

export const getMemberNotificationListMore = data => ({
    types: [GET_MEMBER_NOTIFICATIONLIST_MORE_REQUEST, GET_MEMBER_NOTIFICATIONLIST_MORE_SUCCESS, GET_MEMBER_NOTIFICATIONLIST_MORE_FAILURE],
    promise: backend.getMemberNotificationList(data),
    data
});

export const applyMemberNotificationAction = data => ({
    types: [APPLY_MEMBER_NOTIFICATION_REQUEST, APPLY_MEMBER_NOTIFICATION_SUCCESS, APPLY_MEMBER_NOTIFICATION_FAILURE],
    promise: backend.applyMemberNotificationAction(data),
    data
});

export const receiveInstantNotification = (data, onlyToast = false) =>
    ({ type: RECEIVE_INSTANT_NOTIFICATION, data, onlyToast });


// WEBPACK FOOTER //
// ./src/reducers/memberNotificationList.js